module.exports = __webpack_public_path__ + "static/what-we-do-full-trainings-9b851d4ab53576f6ca3a24a6f1045cfe.jpg";